import React, {Component} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes'
import Paper from 'material-ui/Paper';
import RadioButton from 'material-ui/RadioButton';
import RadioButtonGroup from 'material-ui/RadioButton/RadioButtonGroup';
import RtOvwRetoucher from './RtOvwRetoucher';
import {compare} from '../../utils';
import {Row, Col} from 'react-flexbox-grid';
import {Keys, UIConstants} from "../../model/constants";
import * as Immutable from "immutable";
import moment from "moment";
import OvwCompactIcon from '../images/ovw-compact.svg'
import OvwImageIcon from '../images/ovw-image.svg'
import OvwFullIcon from '../images/ovw-full.svg'
import SvgIcon from 'material-ui/SvgIcon'

class RtOvwPanel extends Component {

    constructor(props) {
        super(props);
        this.handleOver = this.handleOver.bind(this);
        this.handleOut = this.handleOut.bind(this);
        this.handleRequestClose = this.handleRequestClose.bind(this);
        this.handleDisplayModeChange = this.handleDisplayModeChange.bind(this);


        this.state = {
            popoverOpen:false,
            popoverAnchorEl:null,
            popoverItem:null,
            displayMode:UIConstants.RT_OVW_COMPACT
        }
    }

    handleOver(element, item) {
        console.log("Over:", element);

        const newState ={
            popoverOpen:true,
            popoverAnchorEl:element,
            popoverItem:item,
        };
        if ( this.state.popoverOpen) {
            this.setState({popoverOpen:false}, () => {return newState});
        } else
        this.setState(newState);
    }

    handleOut(event) {
        this.setState({popoverOpen:false});
    }

    handleDisplayModeChange(event, value) {
        this.setState({displayMode:value});
    }
    handleRequestClose() {
        this.setState({
            popoverOpen:false
        })
    }
    getAssignees() {
        const assigneeFilter = this.props.assigneeFilter;
        const assigneeItemsGetter = this.props.assigneeItemsGetter;

        let sorted = this.props.assignees.valueSeq()
            .filter(a => assigneeFilter(a))
            .sort(
            (a, b) => compare(a.get(Keys.Assignee.FIRST_NAME), b.get(Keys.Assignee.FIRST_NAME))
                .thenCompare(a.get(Keys.Assignee.LAST_NAME), b.get(Keys.Assignee.LAST_NAME))
                .result()
        );

        return sorted.map(
            (a) => {
                const localItems = assigneeItemsGetter(a, this.props).filter(i => i);

                return (
                    <RtOvwRetoucher key={a.get(Keys.ID)}
                                    id={a.get(Keys.ID)}
                                    firstName={a.get(Keys.Assignee.FIRST_NAME)}
                                    lastName={a.get(Keys.Assignee.LAST_NAME)}
                                    items={Immutable.Set(localItems)}
                                    handleOver={this.handleOver}
                                    handleOut={this.handleOut}
                                    displayMode={this.state.displayMode}
                                    />
                )
            }
        ).toArray();
    }

    render() {
        console.log("Rendering Overview "+moment().format())
        const styles = {
            block: {
                maxWidth: 250,
            },
            radioButton: {
                marginLeft: 0,
                marginRight: 0,
                display:'inline-block',
                overflow:'hidden',
                width:24,
                margin:4
            },
        };
        const checkedStyle = {
            fill:UIConstants.LOOKLET_COLOR_1
        }
        const displayModeClass = "rt-ovw__retoucher-list--"+this.state.displayMode;
        return (
            <Row>
                <Col xs={12} lg={12}>
                    <Paper zDepth={1} onMouseLeave={ this.handleOut} >
                        <div className="rt-ovw__display-selector">
                            <RadioButtonGroup name="displayMode" defaultSelected={this.state.displayMode} onChange={this.handleDisplayModeChange}>
                                <RadioButton
                                    value={UIConstants.RT_OVW_COMPACT}
                                    style={styles.radioButton}
                                    checkedIcon={<SvgIcon viewBox="0 0 24 24" style={checkedStyle}><OvwCompactIcon style={checkedStyle} /></SvgIcon>}
                                    uncheckedIcon={<SvgIcon viewBox="0 0 24 24"><OvwCompactIcon/></SvgIcon>}
                                />
                                <RadioButton
                                    value={UIConstants.RT_OVW_IMAGE}
                                    style={styles.radioButton}
                                    checkedIcon={<SvgIcon viewBox="0 0 24 24"  style={checkedStyle}><OvwImageIcon style={checkedStyle} /></SvgIcon>}
                                    uncheckedIcon={<SvgIcon viewBox="0 0 24 24"><OvwImageIcon/></SvgIcon>}
                                />
                                <RadioButton
                                    value={UIConstants.RT_OVW_FULL}
                                    style={styles.radioButton}
                                    checkedIcon={<SvgIcon viewBox="0 0 24 24" style={checkedStyle} ><OvwFullIcon style={checkedStyle} /></SvgIcon>}
                                    uncheckedIcon={<SvgIcon viewBox="0 0 24 24"><OvwFullIcon/></SvgIcon>}

                                />
                            </RadioButtonGroup>
                        </div>
                        <div className="rt-ovw">
                            <div className="rt-ovw__list-start"></div>
                            <div className={"rt-ovw__retoucher-list "+displayModeClass}>
                                { this.getAssignees()}
                            </div>
                            <div className="rt-ovw__list-end"></div>
                        </div>
                    </Paper>
                </Col>
            </Row>
    )
    }

}
RtOvwPanel.defaultProps = {
    assigneeFilter:(a) =>  {return !a.get(Keys.Assignee.ITEMS, Immutable.Set()).isEmpty()},
    assigneeItemsGetter:(assignee, props) => { return assignee.get(Keys.Assignee.ITEMS, Immutable.Set()).map(itemId => props.items.get(itemId))},

};

RtOvwPanel.propTypes = {
    mutations:ImmutablePropTypes.map.isRequired,
    items:ImmutablePropTypes.map.isRequired,
    assignees:ImmutablePropTypes.map.isRequired,
    assigneeFilter:React.PropTypes.func,
    assigneeItemsGetter:React.PropTypes.func,
};

export default RtOvwPanel



// WEBPACK FOOTER //
// ./src/ui/components/RtOvwPanel.js